module.exports = __webpack_public_path__ + "media/images/tutors/PrepWorks-Jesryna-8c9135fd8d1d9c60795e04db54aa8bae.jpg";